export interface StatementDefinition {
    showMessage: boolean;
    messageText: string;
    messageError: string;
}
